export const INVITE_TYPE = {
    CALL: 'call',
    SHOW_CALL: 'show_call',
    CHAT: 'chat',
    CHAT_SUCCESS: 'chat_success',
    CALLBACK: 'callback',
    WIDGET: 'widget'
};
